import { useTranslation } from 'react-i18next';

import { Label, LABEL_TYPE } from '@/components/generic';
import { TAGS_STYLES, TagValue } from '@/components/generic/Tag/tag-config';
import {
  BlueCheckIcon as CheckIcon,
  ClockIcon,
  CloseCircleIcon,
  InfoCircleIcon,
  MinusCircleIcon,
  RepeatCircleIcon,
  TickCircleIcon
} from '@/resources';

type TagProps = {
  value: string;
  statusDescription?: string;
};

export const Tag = ({ value = '', statusDescription = '' }: TagProps) => {
  const [t] = useTranslation('common');

  const renderIcon = (status: string) => {
    switch (status) {
      case TagValue.PREPARING:
        return <RepeatCircleIcon className='mr-1' aria-hidden />;
      case TagValue.COMPLETED:
        return <TickCircleIcon className='mr-1' aria-hidden />;
      case TagValue.IN_PROGRESS:
        return <ClockIcon className='mr-1' aria-hidden />;
      case TagValue.FAILED:
        return <CloseCircleIcon className='mr-1' aria-hidden />;
      case TagValue.CANCELED:
        return <MinusCircleIcon className='mr-1' aria-hidden />;
      case TagValue.PENDING:
        return <InfoCircleIcon className='mr-1' aria-hidden />;
      case TagValue.DOWNLOADED_FOR_OFFLINE:
        return <CheckIcon className='mr-1 !text-accent-green' />;
      default:
        return null;
    }
  };

  const statusText = t(value?.toLowerCase());
  const labelText = statusDescription ? `${statusText} ${statusDescription}` : statusText;
  const shouldCapitalize = value !== TagValue.DOWNLOADED_FOR_OFFLINE;

  return (
    <div className='flex items-center'>
      <div
        className={`hidden h-[25px] items-center justify-center rounded-[10px] border border-solid px-2 md:flex ${
          shouldCapitalize ? 'capitalize' : ''
        } ${TAGS_STYLES[value]}`}>
        {renderIcon(value)}
        <Label text={labelText} type={LABEL_TYPE.PARAGRAPH2} />
      </div>
      <div className={`md:hidden ${TAGS_STYLES[value]} size-2 rounded-full`} />
    </div>
  );
};
